import {
  DayPickerStrings,
  FlexSpinner,
  FormikGraphQLDatePicker,
  onFormatDate,
} from 'components'
import { EntityList } from 'components/EntityList'
import { ResourceCategory } from 'context'
import { FieldProps } from 'formik'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import {
  Resource,
  ResourceBookingAddInput,
  ResourceBookingBatchInput,
} from 'gql.generated'
import { Box } from 'grid'
import { useCurrentProving } from 'hooks/useCurrentProving'
import useSelection from 'hooks/useSelection'
import _ from 'lodash'
import {
  DayOfWeek,
  Dropdown,
  IDropdownOption,
  Label,
  SelectionMode,
  Stack,
  Text,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'
import { useDoubleBookingsResourceBookingsQuery } from 'views/ProvingDetailsView/hooks'
import * as Yup from 'yup'

export type ProvingDetailsResourceBookingFormValues = ResourceBookingAddInput
export type ProvingDetailsResourceBookingFormUpdateValues =
  ResourceBookingBatchInput
export class ProvingDetailsResourceBookingFormSchema {
  constructor() {
    return Yup.object().shape({
      dateFrom: Yup.date().required(),
      dateTo: Yup.date()
        .when(
          'dateFrom',
          (dateFrom: any, schema: any) => dateFrom && schema.min(dateFrom)
        )
        .required(),
      resources: Yup.string().required(),
    })
  }
}

let dateFromTest1: string
let dateToTest1: string

const ProvingDetailsResourceBookingSelectionList: React.FC<{
  fieldProps: FieldProps<any>
  resources: Resource[]
}> = ({ fieldProps, resources, ...props }) => {
  const { t } = useTranslation()
  const [proving] = useCurrentProving()
  const [resultArray, setResultArray] = useState<any[]>([])
  const { form, field } = fieldProps
  const { data, loading, error } = useDoubleBookingsResourceBookingsQuery()
  const result =
    !loading && data && data.cachedProvings ? data.cachedProvings : []
  dateFromTest1 =
    form.values.dateFrom !== form.initialValues.dateFrom
      ? form.values.dateFrom
      : form.initialValues.dateFrom
  dateToTest1 =
    form.values.dateTo !== form.initialValues.dateTo
      ? form.values.dateTo
      : form.initialValues.dateTo
  const [selection] = useSelection<Resource>({
    onSelectionChanged(selectedItems) {
      form.setFieldValue(field.name, selectedItems)
      checkForDoublebooking(selectedItems, dateFromTest1, dateToTest1)
    },
    getKey: (item) => item._id,
  })

  let usableResources: Resource[] = []
  if (proving.provingGround && proving.provingGround.useUsageTimespansOnly) {
    // Only resources with usageTimespans that are available
    usableResources = resources.filter(
      (r) =>
        r.usageTimespans &&
        r.usageTimespans.some(
          (uts) =>
            form.values.dateFrom >= uts.dateFrom &&
            form.values.dateTo <= uts.dateTo
        )
    )
  } else {
    // Resources without usageTimespans and those with that are available
    usableResources = resources.filter(
      (r) =>
        !r.external ||
        (r.usageTimespans &&
          r.usageTimespans.some(
            (uts) =>
              form.values.dateFrom >= uts.dateFrom &&
              form.values.dateTo <= uts.dateTo
          ))
    )
  }

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = [
    fieldColumn('parent.title', {
      onRender: (item: Resource, i, col) => {
        return (
          <Box key={i} style={{ whiteSpace: 'pre-line' }}>
            {item.parent ? item.parent!.title : '. . .'}
          </Box>
        )
      },
      getGroupValue: (item: Resource) => {
        return item.parent ? item.parent!.title : t(`field.type.${item.type}`)
      },
      isSorted: true,

      ungroupable: true,
      minWidth: 120,
      isGrouped: true,
    }),
    fieldColumn('title', {
      minWidth: 100,
    }),
  ]

  const checkForDoublebooking = (
    res: any,
    dateFrom: string,
    dateTo: string
  ) => {
    let doublebookings = [] as any[]
    const resourcess = res || []
    result.forEach((prov) =>
      (prov.resourceBookings || []).forEach((resourceBooking) => {
        // tslint:disable-next-line: no-unused-expression
        if (resourcess.length > 1) {
          resourcess.forEach((resses: any) => {
            if (
              resourceBooking &&
              resses &&
              (resourceBooking.resource ? resourceBooking.resource._id : '') ===
                (resses as any)._id
            ) {
              const oldBookingFrom = new Date(resourceBooking.dateFrom)
              const oldBookingTo = new Date(resourceBooking.dateTo)
              const newBookingTo = new Date(dateTo)
              const newBookingFrom = new Date(dateFrom)
              if (
                oldBookingTo >= newBookingFrom &&
                oldBookingFrom <= newBookingTo
              ) {
                if (res[0].type === 'workstation') {
                  if (
                    newBookingFrom.toDateString() ===
                      oldBookingTo.toDateString() ||
                    newBookingTo.toDateString() ===
                      oldBookingFrom.toDateString()
                    // tslint:disable-next-line: no-empty
                  ) {
                  } else {
                    doublebookings.push({
                      provingGroundTitle: prov.provingGround
                        ? prov.provingGround.title
                        : '',
                      provingNr: prov.id,
                      department: prov.department,
                      resource: resourceBooking,
                    })
                  }
                  // if (
                  //   newBookingTo.toDateString() !==
                  //   oldBookingFrom.toDateString()
                  // ) {
                  //   doublebookings.push({
                  //     provingGroundTitle: prov.provingGround
                  //       ? prov.provingGround.title
                  //       : '',
                  //     provingNr: prov.id,
                  //     department: prov.department,
                  //     resource: resourceBooking,
                  //   })
                  // }
                } else {
                  doublebookings.push({
                    provingGroundTitle: prov.provingGround
                      ? prov.provingGround.title
                      : '',
                    provingNr: prov.id,
                    department: prov.department,
                    resource: resourceBooking,
                  })
                }
              }
            }
          })
        } else {
          const currentRes = resourcess[0] ? resourcess[0] : ''
          if (
            (resourceBooking && resourcess && resourceBooking.resource
              ? resourceBooking.resource._id
              : '') === currentRes._id
          ) {
            const oldBookingFrom = new Date(resourceBooking.dateFrom)
            const oldBookingTo = new Date(resourceBooking.dateTo)
            const newBookingTo = new Date(dateTo)
            const newBookingFrom = new Date(dateFrom)
            if (
              oldBookingTo >= newBookingFrom &&
              oldBookingFrom <= newBookingTo
            ) {
              if (res[0].type === 'workstation') {
                if (
                  newBookingFrom.toDateString() ===
                    oldBookingTo.toDateString() ||
                  newBookingTo.toDateString() === oldBookingFrom.toDateString()
                  // tslint:disable-next-line: no-empty
                ) {
                } else {
                  doublebookings.push({
                    provingGroundTitle: prov.provingGround
                      ? prov.provingGround.title
                      : '',
                    provingNr: prov.id,
                    department: prov.department,
                    resource: resourceBooking,
                  })
                }
                // if (
                //   newBookingFrom.toDateString() !== oldBookingTo.toDateString()
                // ) {
                //   doublebookings.push({
                //     provingGroundTitle: prov.provingGround
                //       ? prov.provingGround.title
                //       : '',
                //     provingNr: prov.id,
                //     department: prov.department,
                //     resource: resourceBooking,
                //   })
                // }
                //  else if (
                //   newBookingTo.toDateString() !== oldBookingFrom.toDateString()
                // ) {
                //   doublebookings.push({
                //     provingGroundTitle: prov.provingGround
                //       ? prov.provingGround.title
                //       : '',
                //     provingNr: prov.id,
                //     department: prov.department,
                //     resource: resourceBooking,
                //   })
                //   // tslint:disable-next-line: no-empty
                // } else {
                // }
              } else {
                doublebookings.push({
                  provingGroundTitle: prov.provingGround
                    ? prov.provingGround.title
                    : '',
                  provingNr: prov.id,
                  department: prov.department,
                  resource: resourceBooking,
                })
              }
            }
          }
        }
      })
    )
    doublebookings = doublebookings.sort((a, b) =>
      a.resource.resource.title.localeCompare(b.resource.resource.title, 'de', {
        numeric: true,
      })
    )

    setResultArray(doublebookings)
  }

  return (
    <>
      <FlexSpinner loading={loading} error={error}>
        {resultArray && resultArray.length > 0 && (
          <FieldStack>
            <Text variant="xLarge" as="h2">
              ACHTUNG!
            </Text>
            <Stack.Item>
              <Label>
                {t(
                  `Folgende Ressource(n) sind zum Zeitraum ${onFormatDate(
                    new Date(dateFromTest1)
                  )} bis ${onFormatDate(new Date(dateToTest1))} bereits gebucht`
                )}
              </Label>
              {resultArray.map((x: any, i: number) => {
                return (
                  <FieldStack key={i}>
                    <Label>{x.resource.resource.title}</Label>
                    <table>
                      <tbody>
                        <tr>
                          <td>Standort: {x.provingGroundTitle}</td>
                        </tr>
                        <tr>
                          <td>Erprobungsnr.: {x.provingNr}</td>
                        </tr>
                        <tr>
                          <td>Abteilung: {x.department}</td>
                        </tr>
                        <tr>
                          <td>
                            Datum: {onFormatDate(new Date(x.resource.dateFrom))}{' '}
                            bis {onFormatDate(new Date(x.resource.dateTo))}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <hr />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </FieldStack>
                )
              })}
              <Label>{t('Möchten Sie die Ressource trotzdem buchen?')}</Label>
            </Stack.Item>
          </FieldStack>
        )}
        <EntityList
          items={usableResources}
          selection={selection}
          compact={true}
          columns={columns}
          selectionMode={SelectionMode.multiple}
          // onActiveItemChanged={x => checkForDoublebooking(x)}
          // onSelectionChanged={x =>
          //   checkForDoublebooking(x, testDateFrom, testDateTo)
          // }
          disableListStyleToggle={true}
          {...props}
        />
      </FlexSpinner>
    </>
  )
}

export const ProvingDetailsResourceBookingForm: React.FC<{
  resources: Resource[] | undefined
  resourceCategories: ResourceCategory[] | undefined
}> = ({ resourceCategories, resources }) => {
  const [category, setCategory] = React.useState()
  const [type, setType] = React.useState()
  const [currentFilterObj] = React.useState(() => [] as string[])
  const { t } = useTranslation()
  const [proving] = useCurrentProving()
  const categoryOptions = resourceCategories
    ? [
        ...resourceCategories.map(
          (item: ResourceCategory) =>
            ({
              key: item.id,
              text: item.title,
            } as IDropdownOption)
        ),
      ]
    : []

  const filteredCategoryOptions = categoryOptions.filter((x) => {
    if (
      x.key !== 'ferryConnection' &&
      x.key !== 'lodging' &&
      x.key !== 'officeRoom' &&
      x.key !== 'building'
    ) {
      return true
    } else {
      return false
    }
  })

  const typeOptions =
    category && resourceCategories
      ? [
          ...resourceCategories
            .find((x) => x.id === category)!
            .types.map(
              (item: any) =>
                ({
                  key: item.id,
                  text: item.title,
                } as IDropdownOption)
            )
            .filter((y) => {
              if (
                y.key !== 'officeRoom' &&
                y.key !== 'officeContainer' &&
                y.key !== 'conferenceRoom' &&
                y.key !== 'workshop' &&
                y.key !== 'fuel'
              ) {
                return true
              } else {
                return false
              }
            }),
        ]
      : []

  const filteredResources = _.filter(resources, (item: any) => {
    if (
      currentFilterObj &&
      currentFilterObj.length > 0 &&
      item.inactive === false
    ) {
      return item.parentId === currentFilterObj
    } else {
      return item.type === type && item.category === category
    }
  })

  const resourceOptions = filteredResources ? filteredResources : []
  return (
    <FormStack>
      <Label>{t('model.proving.resourceBookings.addResourceBooking')}</Label>

      <FieldStack>
        <Dropdown
          label={t('field.resourceCategory.label')}
          onChanged={(option) => {
            if (option.key) {
              setCategory(option.key)
            }
          }}
          options={filteredCategoryOptions}
        />

        <Dropdown
          label={t('field.resourceBookingType.label')}
          onChanged={(option) => {
            if (option.key) {
              setType(option.key)
            }
          }}
          options={typeOptions}
        />
      </FieldStack>

      <FieldStack horizontal={true}>
        <FieldStackItem
          name={'dateFrom'}
          render={(fieldProps) => (
            <FormikGraphQLDatePicker
              label={'Von'}
              defaultValue={proving.dateFrom}
              // minDate={new Date(proving.dateFrom)}
              // maxDate={new Date(proving.dateTo)}
              firstDayOfWeek={DayOfWeek.Monday}
              strings={DayPickerStrings}
              showWeekNumbers={true}
              formatDate={onFormatDate as any}
              {...fieldProps}
              initialPickerDate={new Date(proving.dateFrom)}
            />
          )}
        />
        <FieldStackItem
          name={'dateTo'}
          render={(fieldProps) => (
            <FormikGraphQLDatePicker
              label={'Bis'}
              defaultValue={proving.dateTo}
              // minDate={new Date(proving.dateFrom)}
              // maxDate={new Date(proving.dateTo)}
              firstDayOfWeek={DayOfWeek.Monday}
              strings={DayPickerStrings}
              showWeekNumbers={true}
              formatDate={onFormatDate as any}
              {...fieldProps}
              initialPickerDate={new Date(proving.dateFrom)}
            />
          )}
        />
      </FieldStack>

      {type && (
        <FieldStack>
          <FieldStackItem
            name={'resources'}
            render={(fieldProps) => (
              <>
                <Label>{t('field.resource.label')}</Label>
                <ProvingDetailsResourceBookingSelectionList
                  resources={resourceOptions}
                  fieldProps={fieldProps}
                  {...fieldProps}
                />
              </>
            )}
          />
        </FieldStack>
      )}
    </FormStack>
  )
}
